import { makeStyles, Container } from '@material-ui/core'
import Editor from 'rich-markdown-editor'
import React from 'react'
import i18n from 'i18next'

const useStyles = makeStyles((theme) => ({
  editor: {
    fontSize: '16px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px'
    }
  }
}))

export default function MarkdownEditor(props) {
  const classes = useStyles()

  const avoidEmptyLines = (value) => {
    while (/\n\\\n/.test(value)) {
      value = value.replace(/\n\\\n/, '\n')
    }

    return value
  }

  return (
    <Container maxWidth="sm">
      <Editor
        className={classes.editor}
        style={{ margin: '3%' }}
        placeholder={props.placeHolder}
        defaultValue={props.defaultValue}
        onChange={(getValue) => {
          props.onChange(avoidEmptyLines(getValue()))
        }}
        handleDOMEvents={{
          blur: props.onblur
        }}
        disableExtensions={['checkbox_item', 'checkbox_list', 'container_notice', 'highlight', 'image', 'strikethrough']}
        dictionary={i18n.t('job_offer.new_job_offer.editor_dictionnary', { returnObjects: true })}
      />
    </Container>
  )
}
